// extracted by mini-css-extract-plugin
export default {"closeButton":"AuxiliaryMachineForm_closeButton__O+hhd"};